<div class="container">
  @if (showTitle) {
    <div class="title">
      {{ title }}
      <nz-tag nzColor="#1062B9" *ngIf="titleTag?.trim()">{{ titleTag }}</nz-tag>
    </div>
    <div class="divider"></div>
  }

  @if (!detailsData) {
    <app-no-data></app-no-data>
  } @else {

    @for (column of detailsMeta?.columns ?? []; track $index) {
      @if (shouldShowColumn(column)) {
        <ng-container
          [ngTemplateOutlet]="detailRow"
          [ngTemplateOutletContext]="{ meta: column }"
        ></ng-container>
      }
    }

    @for (action of detailsMeta?.actions ?? []; track $index) {
      <ng-container
        [ngTemplateOutlet]="detailRow"
        [ngTemplateOutletContext]="{ meta: action }"
      ></ng-container>
    }
  }
</div>

<ng-template #detailRow let-meta="meta">
  <div class="item">
    <div class="item-label">{{ meta.displayName }}</div>
    <div class="item-value">
      <app-tos-table-td
        [value]="CommonUtils.getNestedValue(detailsData, meta.fieldName)"
        [rowData]="detailsData"
        [column]="meta"
        (inlineAction)="handleInlineAction($event)"
      ></app-tos-table-td>
    </div>
  </div>
</ng-template>
